module.exports = __webpack_public_path__ + "media/images/participant-drop-call-3923571b5bad387d99687f4af4717859a113590eec3570dc4a156a3905726cdb.svg";